// src/screens/Achievements/index.tsx

import React, { useEffect, useRef, useState } from 'react';
import {
  View,
  Image,
  Animated,
  Dimensions,
  TouchableOpacity,
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Feather from 'react-native-vector-icons/Feather';
import Carousel, {
  type ICarouselInstance,
} from 'react-native-reanimated-carousel';


import {
  Container,
  HeroSection,
  BackgroundImage,
  GradientOverlay,
  CarDisplayContainer,
  CarImage,
  LevelBadge,
  LevelBadgeText,
  ContentContainer,
  SectionHeader,
  SectionTitle,
  SectionSubtitle,
  ContentList,
  CarCard,
  CarImageWrapper,
  StatusBadge,
  CardData,
  CarInfo,
  CarName,
  CarDescription,
  BenefitsContainer,
  CarBenefitsTextContainer,
  CarBenefitsText,
  CardContent,
  ClubBenefitContainer,
  ClubBenefitText,
  HeaderContainer,
  BackButton,
  CurrentCarContainer,
  CurrentCarTitle,
  Divider,
  CurrentCarDisplay,
  StatCard,
  StatCardValue,
  StatCardLabel,
  SectionNegrito,
  CurrentCarDisplayWrapper,
  StatValueInfo,
  ProgressSection,
  LockOverlay,
  LockIconContainer,
  CarImageContainer,
  SectionLabel,
} from './styles';

import carBackground from '../../../assets/images/carrinhos/car_background.webp';

import { RFValue } from 'react-native-responsive-fontsize';
import { Loading } from '../../../components/Interface/Loadings/Loading';
import { Maintenance } from '../../../components/Interface/Maintenance';
import { Baratinhaz } from '../../../components/Interface/Baratinhaz';
import FontAwesome5Icon from 'react-native-vector-icons/FontAwesome5';
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context';
import { isIphoneX } from 'react-native-iphone-screen-helper';
import { FocusAwareStatusBar } from '../../../context/statusbar';
import { ScrollView } from 'react-native-gesture-handler';
import { useCarrinhos } from '../../../context/useCarrinhos';
import { useGlobal } from '../../../context/global';
import { useTheme } from 'styled-components/native';
import { BadgeProgressBar } from '../../../components/shared/BadgeProgressBar';

const { width: deviceWidth } = Dimensions.get('window');
const CAROUSEL_WIDTH = deviceWidth;
const CAROUSEL_HEIGHT = RFValue(145);

export function Achievements() {
  const { goBack } = useNavigation();
  const theme = useTheme();
  const insets = useSafeAreaInsets();
  const carouselRef = useRef<ICarouselInstance>(null);
  const [activeCarIndex, setActiveCarIndex] = useState(0);

  const { disabledFeatures } = useGlobal();
  const isDisabled = (key: string) => disabledFeatures.includes(key);

  // Hook centralizado para dados dos carrinhos
  const {
    loading,
    error,
    currentCarLabel,
    currentCarIndex: defaultCarouselIndex,
    qtdLitrosMes,
    nextCar,
    nextCarImage,
    remainingLitros,
    progress,
    totalCars,
    carrosDisponiveis,
    getCarImage,
    isCarLocked,
    isCurrentCar,
  } = useCarrinhos();

  // Animações
  const carScale = useRef(new Animated.Value(0.8)).current;
  const carOpacity = useRef(new Animated.Value(0)).current;
  const contentTranslate = useRef(new Animated.Value(50)).current;
  const contentOpacity = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    if (!loading && !error && carrosDisponiveis.length > 0) {
      // Setar o índice inicial para o carro atual
      if (defaultCarouselIndex !== -1) {
        setActiveCarIndex(defaultCarouselIndex);
      }

      // Animação de entrada escalonada
      Animated.sequence([
        Animated.parallel([
          Animated.spring(carScale, {
            toValue: 1,
            friction: 8,
            tension: 40,
            useNativeDriver: true,
          }),
          Animated.timing(carOpacity, {
            toValue: 1,
            duration: 500,
            useNativeDriver: true,
          }),
        ]),
        Animated.parallel([
          Animated.spring(contentTranslate, {
            toValue: 0,
            friction: 10,
            tension: 50,
            useNativeDriver: true,
          }),
          Animated.timing(contentOpacity, {
            toValue: 1,
            duration: 400,
            useNativeDriver: true,
          }),
        ]),
      ]).start();
    }
  }, [loading, error, carrosDisponiveis, defaultCarouselIndex]);


  if (loading) {
    return <Loading />;
  }

  if (isDisabled('conquistas') || error || carrosDisponiveis.length === 0) {
    return (
      <Container style={{ backgroundColor: theme.colors.shape }}>
        <Maintenance />
      </Container>
    );
  }

  return (
    <Container>
      <ScrollView
        contentContainerStyle={{ paddingBottom: RFValue(20) }}
        bounces={false}
        nestedScrollEnabled
        scrollEventThrottle={16}>
        <FocusAwareStatusBar barStyle="light-content" />
        {/* Hero Section com imagem de fundo */}
        <HeroSection>
          <BackgroundImage source={carBackground} resizeMode="cover">
            <GradientOverlay />
          </BackgroundImage>

          {/* Botão Voltar */}

          <HeaderContainer topInset={insets.top}>
            <BackButton onPress={goBack} activeOpacity={0.7}>
              <Feather name="chevron-left" size={RFValue(20)} color="#FFF" />
            </BackButton>

            <LevelBadge>
              <LevelBadgeText>
                Nível {activeCarIndex + 1}/{totalCars}
              </LevelBadgeText>
            </LevelBadge>
          </HeaderContainer>

          {/* Badge de Nível */}

          {/* Carro e Informações - Swiper */}
          <CarDisplayContainer>
            <Animated.View
              style={{
                transform: [{ scale: carScale }],
                opacity: carOpacity,
              }}>
              {/* Seta Esquerda */}
              {activeCarIndex > 0 && (
                <TouchableOpacity
                  onPress={() => carouselRef.current?.prev()}
                  activeOpacity={0.7}
                  style={{
                    position: 'absolute',
                    left: RFValue(8),
                    top: '50%',
                    marginTop: -RFValue(16),
                    zIndex: 10,
                    padding: RFValue(8),
                  }}>
                  <Feather
                    name="chevron-left"
                    size={RFValue(28)}
                    color="rgba(255,255,255,0.7)"
                  />
                </TouchableOpacity>
              )}

              {/* Seta Direita */}
              {activeCarIndex < carrosDisponiveis.length - 1 && (
                <TouchableOpacity
                  onPress={() => carouselRef.current?.next()}
                  activeOpacity={0.7}
                  style={{
                    position: 'absolute',
                    right: RFValue(8),
                    top: '50%',
                    marginTop: -RFValue(16),
                    zIndex: 10,
                    padding: RFValue(8),
                  }}>
                  <Feather
                    name="chevron-right"
                    size={RFValue(28)}
                    color="rgba(255,255,255,0.7)"
                  />
                </TouchableOpacity>
              )}
              <SafeAreaView
                edges={['top']}
                style={{
                  marginTop: isIphoneX() ? -RFValue(10) : 0,

                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <Carousel
                  ref={carouselRef}
                  width={CAROUSEL_WIDTH}
                  height={CAROUSEL_HEIGHT}
                  style={{
                    alignSelf: 'center',
                    marginTop:
                      deviceWidth <= 365
                        ? RFValue(deviceWidth * 0.26) //nexus
                        : deviceWidth <= 384
                          ? RFValue(deviceWidth * 0.21) // iphone se
                          : deviceWidth <= 402
                            ? RFValue(deviceWidth * 0.15) // iphone 16 pro max
                            : deviceWidth <= 412
                              ? RFValue(deviceWidth * 0.23) // pixel 7 pro
                              : RFValue(deviceWidth * 0.13),
                  }}
                  data={carrosDisponiveis}
                  defaultIndex={
                    defaultCarouselIndex >= 0 ? defaultCarouselIndex : 0
                  }
                  panGestureHandlerProps={{
                    activeOffsetX: [-10, 10],
                    failOffsetY: [-5, 5],
                  }}
                  onSnapToItem={index => setActiveCarIndex(index)}
                  loop={false}
                  renderItem={({ item }) => {
                    const carImage = getCarImage(item.carrinho);
                    const locked = isCarLocked(item);

                    return (
                      <View
                        style={{
                          width: CAROUSEL_WIDTH,
                          height: CAROUSEL_HEIGHT,
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}>
                        <CarImageContainer style={{ position: 'relative' }}>
                          <CarImage
                            source={carImage}
                            resizeMode="contain"
                            style={{ opacity: locked ? 0.4 : 1 }}
                          />
                          {locked && (
                            <LockOverlay>
                              <LockIconContainer>
                                <Feather
                                  name="lock"
                                  size={RFValue(32)}
                                  color="#FFF"
                                />
                              </LockIconContainer>
                            </LockOverlay>
                          )}
                        </CarImageContainer>
                      </View>
                    );
                  }}
                />
              </SafeAreaView>
            </Animated.View>
          </CarDisplayContainer>

          {/* Barra de Progresso - Entre hero e content */}
        </HeroSection>
        <SafeAreaView
          edges={['bottom']}
          style={{
            flex: 1,
          }}>
          {/* Conteúdo Principal - Sobrepondo a imagem */}
          <Animated.View
            style={{
              transform: [{ translateY: contentTranslate }],
              opacity: contentOpacity,
            }}>
            <ContentContainer>
              <CurrentCarContainer>
                <CurrentCarTitle>
                  {carrosDisponiveis[activeCarIndex]?.label ?? currentCarLabel}
                </CurrentCarTitle>
                <CurrentCarDisplay>
                  <CurrentCarDisplayWrapper>
                    {/* Card de Litros */}
                    <StatCard>
                      <StatValueInfo>
                        <FontAwesome5Icon
                          name="gas-pump"
                          color={theme.colors.shape}
                          size={RFValue(14)}
                        />
                        <StatCardValue>{qtdLitrosMes}</StatCardValue>
                      </StatValueInfo>
                      <StatCardLabel>litros/itens</StatCardLabel>
                    </StatCard>
                    <Divider />
                    {/* Card de Faltam */}
                    {nextCar && (
                      <>
                        <StatCard>
                          <StatValueInfo>
                            <StatCardValue>+{remainingLitros}</StatCardValue>
                          </StatValueInfo>
                          <StatCardLabel>p/ {nextCar.label}</StatCardLabel>
                        </StatCard>
                        <Divider />
                      </>
                    )}

                    {/* Card de Baratinhaz */}
                    <StatCard>
                      <StatValueInfo>
                        <Baratinhaz />
                        <StatCardValue>
                          +
                          {carrosDisponiveis[activeCarIndex]
                            ?.ganho_por_abastecimento ??
                            carrosDisponiveis[0]?.ganho_por_abastecimento}
                        </StatCardValue>
                      </StatValueInfo>
                      <StatCardLabel>por retirada</StatCardLabel>
                    </StatCard>
                  </CurrentCarDisplayWrapper>
                </CurrentCarDisplay>
              </CurrentCarContainer>

              <ProgressSection>
                <BadgeProgressBar
                  progress={progress}
                  badgeImage={nextCar ? nextCarImage : undefined}

                />
              </ProgressSection>

              <SectionHeader>
                <SectionTitle>Quem retira mais, ganha mais!</SectionTitle>

                <SectionSubtitle>
                  Evolua de carro, desbloqueie níveis, ganhe mais descontos e ganhe baratinhaZ sempre que abastecer.
                  {' '}
                  <SectionNegrito>
                    Lembre-se: todo mês você retorna ao nível inicial para começar uma nova jornada.
                  </SectionNegrito>
                </SectionSubtitle>

                <SectionSubtitle style={{ marginTop: RFValue(12) }}>
                  Qual carro você merece dirigir?
                </SectionSubtitle>
              </SectionHeader>

              <ContentList>
                <SectionLabel>Sua garagem</SectionLabel>
                {carrosDisponiveis.map(c => {
                  const locked = isCarLocked(c);
                  const isCurrent = isCurrentCar(c);
                  const carImage = getCarImage(c.carrinho);

                  return (
                    <CarCard key={c.id.$oid} isCurrent={isCurrent}>
                      <CardContent>
                        <CarImageWrapper>
                          <Image
                            source={carImage}
                            style={{
                              width: RFValue(58),
                              height: RFValue(58),
                              resizeMode: 'contain',
                              opacity: locked ? 0.3 : 1,
                            }}
                          />
                          {!locked && (
                            <StatusBadge unlocked={!isCurrent}>
                              <Feather
                                name="check"
                                size={RFValue(14)}
                                color="#FFF"
                              />
                            </StatusBadge>
                          )}
                        </CarImageWrapper>

                        <CardData>
                          <CarInfo>
                            <CarName locked={locked}>{c.label}</CarName>
                            <CarDescription locked={locked}>
                              {locked
                                ? `Requer ${c.minimo_litros} litros/itens`
                                : 'Desbloqueado!'}
                            </CarDescription>
                          </CarInfo>

                          <BenefitsContainer locked={locked} current={isCurrent}>
                            <CarBenefitsTextContainer>
                              <Baratinhaz />
                              <CarBenefitsText
                                locked={locked}
                                current={isCurrent}>
                                +{c.ganho_por_abastecimento}
                              </CarBenefitsText>
                            </CarBenefitsTextContainer>
                          </BenefitsContainer>
                        </CardData>
                      </CardContent>

                      {(c.carrinho === 'avancado2' || c.carrinho === 'lendario') && (
                        <ClubBenefitContainer locked={locked}>
                          <Feather
                            name="award"
                            size={RFValue(14)}
                            color={locked ? 'rgba(139, 92, 246, 0.6)' : '#8B5CF6'}
                          />
                          <ClubBenefitText locked={locked}>
                            Acesso ao clube de vantagens (em breve)
                          </ClubBenefitText>
                        </ClubBenefitContainer>
                      )}
                    </CarCard>
                  );
                })}
              </ContentList>
            </ContentContainer>
          </Animated.View>
        </SafeAreaView>
      </ScrollView>
    </Container>
  );
}
